export default __webpack_public_path__ + "static/media/gallery-wip-neck-base_07.436a1663.jpg";